import React, { useEffect, useState, useRef, useContext } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import NationalityDropdown from '../partials/NationalityDropdown';
import useIsMobile from '../../customHooks/useIsMobile';
import AuthService from '@apiService/AuthService';
import secureStorage from '../../utils/secureStorage';
import {
  Row,
  Nav,
  Tabs,
  Tab,
  Container,
  Col,
  Dropdown,
  Modal,
  Alert,
  Spinner,
  Button,
} from 'react-bootstrap';
import redoEdit from '@assets/pictures/svgs/redo-edit.svg';
import { updateUser } from '../../store/auth/authActions';
import { withNamespaces } from 'react-i18next';
import moment from 'moment';
import userService from '@apiService/userService';

const EditAccount = ({ setToggleEdit, ...props }) => {
  const isMobile = useIsMobile();
  const { t } = props;
  const dispatch = useDispatch();
  const [email, setEmail] = useState(``);
  const [firstName, setFirstName] = useState(``);
  const [editable, setEditable] = useState(false);
  const [lastName, setLastName] = useState(``);
  const [password, setPassword] = useState(``);
  const [phone_no, setPhone_no] = useState(``);
  // const [dob, setDob] = useState(``);
  const [dob, setdob] = useState(null);
  const [nationalId, setNationalId] = useState(null);
  const [nationalCode, setNationalCode] = useState(null);
  const [nayionalityName, setNationalityName] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const loginDetails = useSelector((state) => state.auth);
  const { loginError, loggedInUser, guestUser } = loginDetails;
  const [userData, setUserData] = useState(null);
  const [nationalityData, setNationalityData] = useState(null);
  // console.log(loggedInUser, 'loggedInUser');
  const capitalizeFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  useEffect(() => {
    if (loggedInUser) {
      setFirstName(loggedInUser?.first_name);
      setLastName(loggedInUser?.last_name);
      setEmail(loggedInUser?.cust_email);
      setPhone_no(loggedInUser?.cust_mobile);
      // setDob(loggedInUser?.cust_dob);
      setdob(loggedInUser?.cust_dob ? loggedInUser?.cust_dob : loggedInUser?.dob);
    } else if (guestUser) {
      setFirstName(guestUser?.guest_first_name);
      setLastName(guestUser?.guest_last_name);
      setEmail(guestUser?.guest_email);
      setPhone_no(guestUser?.guest_mobile);
      setSelectedDate(loggedInUser?.cust_dob);
    }
  }, [loggedInUser, guestUser]);
  // const userData = secureStorage.getItem('userdata')
  //   ? JSON.parse(secureStorage.getItem('userdata'))
  //   : null;
  // console.log(userData, 'userData');
  const isFetched = useRef(false);
  useEffect(() => {
    const fetchNationalities = async () => {
      try {
        const { data } = await userService.GetAllNationality();
        if (data.status && data.Records.length > 0) {
          setNationalityData(data?.Records);

          if (loggedInUser && loggedInUser?.customer_nationality) {
            setNationalId(loggedInUser?.customer_nationality);
            let nationShortCode = data?.Records?.find((data) => {
              return data?.nationality_id == loggedInUser?.customer_nationality;
            })?.nationality_country_code;

            let nationName = data?.Records?.find((data) => {
              return data?.nationality_id == loggedInUser?.customer_nationality;
            })?.nationality;

            setNationalCode(nationShortCode || '');
          }

          //console.log(countries, 'countriescountries');
          // console.log('DATA Nationality', data?.Records);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchNationalities();
  }, []);
  useEffect(() => {
    // console.log(loggedInUser, 'loggedInUser');
    if (loggedInUser) {
      // console.log('Inside Logged In user');
      if (!isFetched.current) {
        isFetched.current = true;
        const fetchData = async () => {
          let payload = {
            cust_id: loggedInUser?.cust_id,
          };

          const { data } = await AuthService.getUserDetailMycinemaApi(payload);
          if (data?.status) {
            setUserData(data?.Records[0]);
            // secureStorage.setItem('userdata', JSON.stringify(data.Records[0]));
          }
        };
        fetchData();
      }
    }
  }, [loggedInUser]);
  const onClickUpdateUser = () => {
    if (loggedInUser && !guestUser) {
      dispatch(
        updateUser({
          first_name: firstName,
          last_name: lastName,
          callback: setToggleEdit,
          email,
          phone_no,
          dob,
          customer_nationality: nationalId,
        }),
      );
      setEditable(false);
    }
  };

  return (
    <>
      <div className={`custom-form test col-md-8 ${isMobile ? '' : 'col-6'}`}>
        <div>
          <label>{t('login_form.First Name')}</label>
          <input
            type="text"
            className="form-control"
            value={firstName}
            required
            disabled={!loggedInUser && guestUser ? true : undefined}
            onChange={(e) => {
              setFirstName(e.target.value);
              setEditable(true);
            }}
          />
        </div>
        <div>
          <label>{t('login_form.Last Name')}</label>
          <input
            type="text"
            className="form-control"
            value={lastName}
            disabled={!loggedInUser && guestUser ? true : undefined}
            onChange={(e) => {
              setLastName(e.target.value);
              setEditable(true);
            }}
          />
        </div>
        <div className="email-span">
          <label>{t('Email')}</label>
          <input
            style={{ backgroundColor: 'darkgrey', color: 'grey' }}
            type="text"
            className="form-control"
            value={userData ? userData.cust_email : email}
            required
            disabled
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div>
          <label>Date Of Birth</label>
          {/* <span> {t('login_form.DateOfBirth')} </span> */}
          <div className="">
            <input
              className="new_form_control"
              type="date"
              id="start"
              value={moment(dob).format('YYYY-MM-DD') ?? loggedInUser?.dob}
              name="dateofbirth"
              placeholder={t('login_form.DateOfBirth')}
              min="1920-01-01"
              max={moment().format('YYYY-MM-DD')}
              onChange={(e) => {
                // setSelectedDate(e?.target?.value);
                setdob(e?.target?.value);
                setEditable(true);
              }}
            />
          </div>
          {/* <p className="error">
                    {submitted &&
                      !selectedDate &&
                      dobError &&
                      t('Please enter birth date')}
                  </p> */}
          {/* </label> */}
        </div>
        {/* Nationality Selection */}
        <div>
          <label>Nationality</label>
          {/* <span> {t('login_form.DateOfBirth')} </span> */}
          <div className="">
            <NationalityDropdown
              className="national_code_drop mr-2 custom_country_drop"
              onSelectCountry={({
                nationality_id,
                nationality_country_code,
                nationality,
              }) => {
                setNationalId(nationality_id);
                setNationalCode(nationality_country_code);
                setEditable(true);
              }}
              nationalityData={nationalityData}
            />
          </div>
          {/* <p className="error">
                    {submitted &&
                      !selectedDate &&
                      dobError &&
                      t('Please enter birth date')}
                  </p> */}
          {/* </label> */}
        </div>
      </div>

      <div className={`${isMobile ? 'col-md-8' : 'col-8'}`}>
        <label className="new_head">{t('login_form.Phone Number')}</label>
        <div className="d-flex">
          {/* <CountryCodeDropdown
              className="form-control mr-2"
              onSelectCountry={({ country_id, country_mob_code }) => {
                setCountryId(country_id);
                setCountryMobCode(country_mob_code);
              }}
            /> */}
          {loggedInUser?.country_mob_code && (
            <input
              style={{ backgroundColor: 'darkgrey', color: 'grey' }}
              type="number"
              name=""
              id=""
              value={loggedInUser?.country_mob_code}
              className="new_form_control mr-2 w-25"
              disabled
            />
          )}
          <input
            style={{ backgroundColor: 'darkgrey', color: 'grey' }}
            type="text"
            className="new_form_control"
            value={phone_no}
            required
            disabled
            min="10"
            onChange={(e) => setPhone_no(e.target.value)}
          />
        </div>
      </div>

      {editable && (
        <div className="d-flex justify-content-center align-items-center mb-4 mb-md-5 flex-column flex-md-row">
          <button
            className="btn-main mr-md-4 mb-3 mb-md-0"
            onClick={() => onClickUpdateUser()}
          >
            {t('Confirm')}
          </button>
          <button
            className="btn-basic"
            onClick={() => {
              setToggleEdit(false);
              setEditable(false);
            }}
          >
            {capitalizeFirstLetter(t('Cancel'))}
          </button>
        </div>
      )}
    </>
  );
};

const UserSettings = (props) => {
  //Start Edit Account
  //End Edit Account
  const loginDetails = useSelector((state) => state.auth);
  const { loginError, loggedInUser, guestUser } = loginDetails;
  const [toggleEdit, setToggleEdit] = useState(false);
  const { t } = props;
  return (
    <div className="user-settings">
      {false && (
        <div className="header">
          <h5 className="font-weight-bold">{t(`User Settings`)}</h5>
          {/* <img
          src={redoEdit}
          alt="redo-edit"
          className="redo-icon"
          onClick={() => setToggleEdit((prev) => !prev)}
        /> */}
        </div>
      )}
      <div className="content">
        {/* <div>
          <p>
            {t("login_form.First Name")} {t("login_form.Last Name")}
          </p>
          <p>
            {loggedInUser?.first_name} {loggedInUser?.last_name}
          </p>
        </div>
        <div>
          <p>{t("Email")}</p>
          <p>{loggedInUser?.cust_email}</p>
        </div>
        <div>
          <p>{t("login_form.Phone Number")}</p>
          <p>{loggedInUser?.cust_mobile}</p>
        </div> */}
        {/* <div className="close-account text-right">
          <span className="text-primary font-weight-bold">
            Close my account
          </span>
        </div> */}
        {/* {toggleEdit && ( */}
        <EditAccount t={t} setToggleEdit={setToggleEdit} />
        {/* )} */}
      </div>
    </div>
  );
};

export default withNamespaces()(UserSettings);
